import * as yup from "yup";

export const updateCaseTermsOfPaymentSchema = yup.object().shape({
  caseId: yup.string().required("Case Id is required"),
  termsOfPaymentId: yup.string().required("Terms of payment Id is required"),
});
